import { render, staticRenderFns } from "./IconLinkComponent.vue?vue&type=template&id=2f30ddac&"
import script from "./IconLinkComponent.vue?vue&type=script&lang=ts&"
export * from "./IconLinkComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f30ddac')) {
      api.createRecord('2f30ddac', component.options)
    } else {
      api.reload('2f30ddac', component.options)
    }
    module.hot.accept("./IconLinkComponent.vue?vue&type=template&id=2f30ddac&", function () {
      api.rerender('2f30ddac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/IconLinkComponent.vue"
export default component.exports